import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import Toggle from 'react-toggle';
import Select from 'react-select';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class PaymentTransportAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.locale = getLocale();

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      schedule_grade_id: '',
      staff_id: '',
      daily_currency: 'BRL',
      training_selected: 0,
      ignores_debts: 0,
      daily_value: 0,
      daily_paid: 0,
      bonus: '',
      certification_supplier: '',
      certification_supplier_id: '',
      daily_currency_list: [
        {value: "EUR", label: this.locale.PagamentosDeEscala.AdicionarPagamentoTransporte.opcoesMoedas.Euro},
        {value: "USD", label: this.locale.PagamentosDeEscala.AdicionarPagamentoTransporte.opcoesMoedas.Dolar},
        {value: "BRL", label: this.locale.PagamentosDeEscala.AdicionarPagamentoTransporte.opcoesMoedas.Real},
      ],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.add = this.add.bind(this);
    this.handleSelectChangeStaff = this.handleSelectChangeStaff.bind(this);
    this.loadStaffData = this.loadStaffData.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }

  handleChangeDaily (name, event) {
    var change = {};
    change[name] = event.target.value;

    this.setState(change);
    this.handleChangeDailyTotal(event.target.value, this.state.daily_paid);
  }
  handleChangeDailyPaid (name, event) {
    var change = {};
    change[name] = event.target.value;

    this.setState(change);
    this.handleChangeDailyTotal(this.state.daily_value, event.target.value);
  }

  handleChangeDailyTotal (daily_paid, daily_value) {
    var daily_paid = daily_paid.toString().replace(',', '.');
    var daily_value = daily_value.toString().replace(',', '.');
    var total = daily_paid * daily_value;

    this.setState({daily_total: total});
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }


  handleSelectChangeStaff(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
      this.setState(change, ()=> {
        this.setState({daily_value: ''});
      });
    } else {
      change[name] = event.value;
      this.setState(change, ()=> {
        this.loadStaffData(event);
      });
    }
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }


  loadStaffData(event) {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/pagamento/valores/funcionario/' + event.value;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          Object.keys(responseJson.data).map(function(k) {
            if (responseJson.data[k].type === 'transport' && responseJson.data[k].currency === self.state.daily_currency) {
              self.setState({daily_value: responseJson.data[k].value_str});
            }
            return true;
          });
        }
        self.handleAlert('', '', 'closed');
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      });
    });
  }


  loadData () {
    this.handleAlert('', '', 'open');
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/escala/grade/lista/completo';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({schedule_grades_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/tripulantes/ativos/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({staffs_list: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); /* Overlay */ }); /* Lista de staffs */
    });
  }

  add(event) {
    event.preventDefault();
    var datasave = {
      schedule_grade_id: this.state.schedule_grade_id,
      staff_id: this.state.staff_id,
      daily_value: this.state.daily_value,
      daily_paid: this.state.daily_paid,
      daily_total: this.state.daily_total,
      daily_currency: this.state.daily_currency,
      observation: this.state.observation,
      ignores_debts: this.state.ignores_debts,
      type: 'transport',
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/pagamento/escala/diaria/cadastrar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/escala/pagamentos/abertos/transporte';
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.PagamentosDeEscala.AdicionarPagamentoTransporte.titulo}</h3>
      <Link to="/escala/pagamentos/abertos/transporte" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.PagamentosDeEscala.AdicionarPagamentoTransporte.formulario.EscalaGrade}:</label>
              <Select
                className="form-field-name"
                name="schedule_grade_id"
                value={this.state.schedule_grade_id}
                searchable={true}
                placeholder={this.locale.PagamentosDeEscala.AdicionarPagamentoTransporte.formulario.placeholder.SelecionarEscala}
                onChange={this.handleSelectChange.bind(this, 'schedule_grade_id')}
                options={this.state.schedule_grades_list}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.PagamentosDeEscala.AdicionarPagamentoTransporte.formulario.Tripulante}:</label>
              <Select
                className="form-field-name"
                name="staff_id"
                value={this.state.staff_id}
                placeholder={this.locale.PagamentosDeEscala.AdicionarPagamentoTransporte.formulario.placeholder.SelecionarTripulante}
                onChange={this.handleSelectChangeStaff.bind(this, 'staff_id')}
                options={this.state.staffs_list}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.PagamentosDeEscala.AdicionarPagamentoTransporte.formulario.Quantidade}:</label>
              <input value={this.state.daily_paid} name="daily_paid" className="form-control" onChange={this.handleChangeDailyPaid.bind(this, 'daily_paid')} placeholder="" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.PagamentosDeEscala.AdicionarPagamentoTransporte.formulario.Valor}:</label>
              <input value={this.state.daily_value} name="daily_value" className="form-control" onChange={this.handleChangeDaily.bind(this, 'daily_value')} placeholder="" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.PagamentosDeEscala.AdicionarPagamentoTransporte.formulario.Moeda}:</label>
              <Select
                className="form-field-name"
                name="daily_currency"
                value={this.state.daily_currency}
                placeholder={this.locale.PagamentosDeEscala.AdicionarPagamentoTransporte.formulario.placeholder.SelecionarMoeda}
                onChange={this.handleSelectChange.bind(this, 'daily_currency')}
                options={this.state.daily_currency_list}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.PagamentosDeEscala.AdicionarPagamentoTransporte.formulario.ValorTotal}:</label>
              <input value={this.state.daily_total} disabled="disabled" name="daily_total" className="form-control" onChange={this.handleChangeDaily.bind(this, 'daily_total')} placeholder="" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.PagamentosDeEscala.AdicionarPagamentoTransporte.formulario.Observacao}:</label>
              <input value={this.state.observation} name="observation" className="form-control" onChange={this.handleChange.bind(this, 'observation')} placeholder={this.locale.PagamentosDeEscala.AdicionarPagamentoTransporte.formulario.placeholder.Observacao} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.PagamentosDeEscala.AdicionarPagamentoTransporte.formulario.IgnorarSaldoDevedor}?</label>
              <br/>
              <Toggle
                defaultChecked={this.state.ignores_debts}
                checked={this.state.ignores_debts}
                aria-label='No label tag'
                name="ignores_debts"
                onChange={this.handleToggleChange.bind(this, 'ignores_debts')} />
            </div>
          </div>
        </div>        
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.PagamentosDeEscala.AdicionarPagamentoTransporte.formulario.botaoSalvarPagamento}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default PaymentTransportAdd;



// WEBPACK FOOTER //
// ./src/Components/SchedulePayments/PaymentTransportAdd.js